import React, { Component } from 'react';
import ReactTable from 'react-table';
import reqwest from 'reqwest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelopeOpenText, faPlus, faPhone } from '@fortawesome/pro-solid-svg-icons';

import history from '../../history';
import settings from '../../../settings';
import Loader from '../../components/Loader';
import Searchbar from '../../components/Searchbar';
import Button from '../../components/Button';

class OfficeManagementOverview extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search.toLowerCase();
    }

    this.state = {
      loading: true,
      data: [],
      searchString,
    };
  }

  componentDidMount() {
    const promise = reqwest({
      method: 'get',
      url: settings.office.general.getList,
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(res => {
      this.setState({
        data: JSON.parse(res).officeList,
      });
    });

    Promise.all([promise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  _search = value => {
    const val = value.toLowerCase();

    history.replace(val ? `/officemanagement/search/${val}` : '/officemanagement');

    this.setState({
      searchString: val,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.data.filter(rowData =>
      [rowData.CCR, rowData.Name, rowData.Zip, rowData.Street, rowData.City, rowData.Email, rowData.Tel]
        .map(e => e.toLowerCase())
        .some(v => {
          return v.indexOf(this.state.searchString) >= 0;
        }),
    );

    return (
      <>
        <div className='Toolbar'>
          <Searchbar placeholder='Büro suchen...' defaultValue={this.state.searchString} onChange={this._search} />
          <div className='Toolbar-buttons'>
            <Button icon={faPlus} to='/officemanagement/new'>
              Büro erstellen
            </Button>
          </div>
        </div>
        <ReactTable
          getTrProps={(_, { original }) => ({
            onClick: () => this.props.history.push(`/officemanagement/${original.Guid}`),
          })}
          data={data}
          pageSize={data.length}
          noDataText='Es wurden keine Büros gefunden.'
          defaultSorted={[
            {
              id: 'CCR',
              desc: false,
            },
          ]}
          columns={[
            {
              Header: 'Name',
              accessor: 'Name',
              maxWidth: 250,
            },
            {
              id: 'CCR',
              Header: 'KST',
              accessor: 'CCR',
              maxWidth: 200,
            },
            {
              id: 'address',
              Header: 'Kontaktdaten',
              Cell: ({ original }) => (
                <>
                  <FontAwesomeIcon fixedWidth icon={faEnvelopeOpenText} /> {original.Email}
                  <br />
                  <FontAwesomeIcon fixedWidth icon={faMapMarkerAlt} /> {original.Street}, {original.Zip} {original.City}
                  <br />
                  <FontAwesomeIcon fixedWidth icon={faPhone} /> {original.Tel}
                </>
              ),
            },
          ]}
        />
      </>
    );
  }
}

export default OfficeManagementOverview;
